// Generated by CoffeeScript 1.12.7
var CouldNotLoad, createMessage, makePath,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

makePath = require('./make-path');

createMessage = function(base, module, callers) {
  return callers.reduce(function(acc, item, i) {
    return acc.concat(makePath(base, module, callers.slice(0, +i + 1 || 9e9)));
  }, []);
};

CouldNotLoad = (function(superClass) {
  extend(CouldNotLoad, superClass);

  function CouldNotLoad(base1, module1, callers1, underlyingError) {
    var places;
    this.base = base1;
    this.module = module1;
    this.callers = callers1;
    this.underlyingError = underlyingError;
    places = createMessage(this.base, this.module, this.callers);
    this.message = "Could not load module " + this.module + ". Tried in these places:\n" + (places.join(',\n'));
  }

  return CouldNotLoad;

})(Error);

module.exports = CouldNotLoad;
